import type { OrderWarehouseSummary } from '../types/orderWarehouseSummary';
import { reportDtoAnomaly } from './common';

const isAmount = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);

/** A failed or redacted read must never look like zero stock or zero cost. */
export function normalizeOrderWarehouseSummary(raw: unknown): OrderWarehouseSummary {
  const value = raw as OrderWarehouseSummary | null;
  const invalid = () => {
    reportDtoAnomaly('OrderWarehouseSummary', 'payload', raw);
    throw new Error('Invalid warehouse summary');
  };
  if (!value || !Array.isArray(value.lines) || !Array.isArray(value.documents)) return invalid();
  if (value.lines.some(line => !line || typeof line.id !== 'string' || typeof line.name !== 'string'
    || typeof line.unit !== 'string'
    || !isAmount(line.orderedQuantity)
    || ![line.availableQuantity, line.issuedQuantity, line.remainingQuantity, line.invoicedQuantity].every(amount => amount === null || isAmount(amount)))) return invalid();
  if (value.documents.some(document => !document || typeof document.id !== 'string'
    || typeof document.wzNumber !== 'string' || typeof document.status !== 'string')) return invalid();
  if (value.finance != null && (![value.finance.knownFifoCostPLN, value.finance.transportCostPLN, value.finance.otherCostPLN].every(isAmount)
    || typeof value.finance.costPending !== 'boolean')) return invalid();
  return {
    lines: value.lines,
    documents: value.documents,
    ...(value.finance != null ? { finance: value.finance } : {}),
  };
}
